import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import classNames from "classnames";
import { __ } from "@jti/fe-common";
import { InputFooter, InputLabel } from "../../partials/form-blocks/FormBlocks";
import "./Textarea.scss";
const Textarea = ({ label, id, placeholder, disclaimer, requiredMessage, formConfig, validationRules, errorMessage, }) => {
    const hasErrors = Boolean(formConfig?.errors[id]);
    const validateField = async () => {
        await formConfig?.trigger(id);
    };
    const getValidationMessage = () => {
        if (formConfig?.errors[id]?.type === "required") {
            return requiredMessage || __("contact.form.requiredmessage");
        }
        return errorMessage;
    };
    const labelId = id ? `label-${id.replace(/\s+/g, "-")}` : undefined;
    return (_jsx(_Fragment, { children: _jsxs("div", { className: classNames("aem-text-area", {
                "aem-text-area--invalid": hasErrors,
            }), id: id, children: [_jsx(InputLabel, { label: label, htmlFor: id, id: labelId, required: validationRules?.required }), _jsx("textarea", { ...formConfig?.register(id, validationRules), "aria-labelledby": labelId, "data-testid": "textarea-element", tabIndex: 0, onBlur: validateField, placeholder: placeholder, name: id, className: "aem-text-area__input" }), _jsx(InputFooter, { displayError: hasErrors, disclaimer: disclaimer, message: getValidationMessage() })] }) }));
};
export default Textarea;
//# sourceMappingURL=Textarea.js.map